import cookies from 'js-cookie'
import { AUTH_COOKIE_SETTINGS } from '../auth'

const WELCOME_VIDEO_MODAL_COOKIE = 'homebot-welcome-video-modal-shown'
const SEARCH_PROFILE_ONBOARDING_COOKIE = 'homebot-search-profile-onboarding-shown'

export const hasWelcomeVideoModalBeenShown = (): boolean => {
  return cookies.get(WELCOME_VIDEO_MODAL_COOKIE) === 'true'
}

// Needs to get to 3 before we show the search profile onboarding card
export const getSearchProfileOnboardingShownCount = (): number => {
  return parseInt(cookies.get(SEARCH_PROFILE_ONBOARDING_COOKIE) || '0')
}

export const incrementSearchProfileOnboardingShownCount = (): void => {
  const currentCount = getSearchProfileOnboardingShownCount()
  if (currentCount >= 3) {
    return
  }
  cookies.set(SEARCH_PROFILE_ONBOARDING_COOKIE, (currentCount + 1).toString(), {
    ...AUTH_COOKIE_SETTINGS,
    expires: 365 // Keep this cookie for a year
  })
}

export const markWelcomeVideoModalAsShown = (): void => {
  cookies.set(WELCOME_VIDEO_MODAL_COOKIE, 'true', {
    ...AUTH_COOKIE_SETTINGS,
    expires: 365 // Keep this cookie for a year
  })
}